import { render, staticRenderFns } from "./Trivia3.vue?vue&type=template&id=d6320f0c&scoped=true&"
import script from "./Trivia3.vue?vue&type=script&lang=js&"
export * from "./Trivia3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6320f0c",
  null
  
)

export default component.exports